import React, { useState } from 'react';
import styled from 'astroturf/react';
import { SimplePaperPodcast } from 'js/podcast_ai/SimplePaperPodcast';
import { Button } from 'js/design_system/Button';
import { fetchWithCsrf } from 'js/utils';
import routes from 'sitewide-js/core_pre_webpack/routes';
import _Container from "ProfileList-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/ProfileList.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

type Podcast = {
  id: number;
  workId: number;
  workTitle: string;
};

type Props = {
  userId: number;
  initialPodcasts: Podcast[];
  hasMore?: boolean;
  onsitePodcastPromotion?: boolean;
};

export const ProfileList: React.FC<Props> = ({
  initialPodcasts,
  userId,
  hasMore = false,
  onsitePodcastPromotion = false,
}) => {
  const [podcasts, setPodcasts] = useState<Podcast[]>(initialPodcasts);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMorePodcasts, setHasMorePodcasts] = useState(hasMore);

  const loadMorePodcasts = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const response = await fetchWithCsrf(
        routes.api_v0_ai_podcast_list_path({
          subdomain_param: 'api',
          user_id: userId,
          page: page + 1,
        }),
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        setPodcasts((prev) => [...prev, ...data.podcasts]);
        setPage((prev) => prev + 1);
        setHasMorePodcasts(data.hasMore);
      }
    } catch (error) {
      console.error('Failed to load more podcasts:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      {podcasts.map((podcast) => (
        <SimplePaperPodcast
          key={podcast.id}
          workId={podcast.workId}
          workTitle={podcast.workTitle}
          onsitePodcastPromotion={onsitePodcastPromotion}
        />
      ))}

      {hasMorePodcasts && (
        <div>
          <Button
            size="sm"
            inverse
            fullWidth
            onClick={loadMorePodcasts}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'See more'}
          </Button>
        </div>
      )}
    </Container>
  );
};
